/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAssignmentRuleRequest
 */
export interface UpdateAssignmentRuleRequest {
    /**
     * 
     */
    owner_user_id?: string;
    /**
     * 
     */
    liaison_user_ids?: Array<string>;
}

/**
 * Check if a given object implements the UpdateAssignmentRuleRequest interface.
 */
export function instanceOfUpdateAssignmentRuleRequest(value: object): value is UpdateAssignmentRuleRequest {
    return true;
}

export function UpdateAssignmentRuleRequestFromJSON(json: any): UpdateAssignmentRuleRequest {
    return UpdateAssignmentRuleRequestFromJSONTyped(json, false);
}

export function UpdateAssignmentRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssignmentRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner_user_id': json['owner_user_id'] == null ? undefined : json['owner_user_id'],
        'liaison_user_ids': json['liaison_user_ids'] == null ? undefined : json['liaison_user_ids'],
    };
}

export function UpdateAssignmentRuleRequestToJSON(json: any): UpdateAssignmentRuleRequest {
    return UpdateAssignmentRuleRequestToJSONTyped(json, false);
}

export function UpdateAssignmentRuleRequestToJSONTyped(value?: UpdateAssignmentRuleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['owner_user_id'],
        'liaison_user_ids': value['liaison_user_ids'],
    };
}

